import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { getAlertaTemprana, getCreditos, getEvaluaciones, getSubcalculosIndProduc } from '../../riesgo-liquidez/query';
import { firstValueFrom } from 'rxjs';
import { FuncionesMes } from '../../../elements/funciones/funcionesGenerales';
import { getDetalleCuenta, getVariable } from '../indicadores-cobertura/query';

@Injectable({
  providedIn: 'root'
})
export class IndicadicadoresProductividadService {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private apollo: Apollo,
    private cookieService: CookieService
  ) { }

  /**
 * Obtiene las evaluaciones por plantilla
 */
  async getEvaluacionesByPlantilla(plantilla: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers },
          variables: { idPlantilla: plantilla }
        }).valueChanges
      );
      return data.evaluaciones;
    } catch (err) {
      return null;
    }
  }

  /**
   * Obtiene datos de cuentas para múltiples evaluaciones
   */
  async getDataCuentasMultiple(cadenaEvaluacion: any[]) {
    const promises = [];

    for (const eva of cadenaEvaluacion) {
      const promise = this.getDataCuenta(eva.idEvaluacion)
        .then((value) => ({
          idCuenta: value.idCuenta,
          idEvaluacion: value.idEvaluacion,
          valor: value.valor,
          eval: eva.evaluacion
        }));
      promises.push(promise);
    }

    return await Promise.all(promises);
  }

  /**
   * Obtiene datos de una cuenta específica
   */
  private async getDataCuenta(idEvaluacion: number) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getAlertaTemprana,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idCuenta: "G51202" }
        }).valueChanges
      );
      return {
        idCuenta: data.detalleEvaluacionCuenta['idCuenta'],
        idEvaluacion: data.detalleEvaluacionCuenta['idEvaluacion'],
        valor: data.detalleEvaluacionCuenta['valor']
      };
    } catch (err) {
      return null;
    }
  }

  /**
   * Obtiene datos de créditos para múltiples evaluaciones
   */
  async getDataCreditosMultiple(cadenaEvaluacion: any[]) {
    const promises = [];

    for (const eva of cadenaEvaluacion) {
      const promise = this.getDataCredito(eva.an, eva.mes)
        .then((value) => ({
          ...value,
          idEvaluacion: eva.idEvaluacion
        }));
      promises.push(promise);
    }

    return await Promise.all(promises);
  }

  /**
   * Obtiene datos de créditos por período
   */
  private async getDataCredito(an: string, mes: string) {
    try {
      const mesFull = FuncionesMes.f_switchmes3(mes);
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getCreditos,
          context: { headers: this.headers },
          variables: { periodo: an + "-" + mesFull + '-01' }
        }).valueChanges
      );

      return {
        cre_01: data.creditos_sub_calculos['CRE_01'].value,
        cre_02: data.creditos_sub_calculos['CRE_02'].value,
        cre_03: data.creditos_sub_calculos['CRE_03'].value,
        cre_04: data.creditos_sub_calculos['CRE_04'].value,
        cre_05: data.creditos_sub_calculos['CRE_05'].value,
        cre_06: data.creditos_sub_calculos['CRE_06'].value,
        cre_07: data.creditos_sub_calculos['CRE_07'].value,
        cre_08: data.creditos_sub_calculos['CRE_08'].value,
        cre_09: data.creditos_sub_calculos['CRE_09'].value,
        cre_10: data.creditos_sub_calculos['CRE_10'].value,
        cre_11: data.creditos_sub_calculos['CRE_11'].value,
        cre_12: data.creditos_sub_calculos['CRE_12'].value,
        cre_13: data.creditos_sub_calculos['CRE_13'].value,
      };
    } catch (err) {
      return null
    }
  }

  /**
   * 
   * @param idInstitucion id de la institucion del administrador
   * @param periodos arreglo de objetos {anio: number, mes: number}
   */
  async getDataIndicadores(idInstitucion: string, periodos: {anio: number, mes:number}[]){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
          query: getSubcalculosIndProduc,
          context: { headers: this.headers },
          variables: { idInstitucion: idInstitucion, periodos: periodos }
        }).valueChanges
      );

      return data.subcalculosIndicadores;
    }catch(e){
      return null;
    }
  }
  /** 
   * @param idEvaluacion id numerico de la evaluacion AT 
   * @param idVariable string del codigo de la variable a consultar
   * @returns 
   */
  async getVariable(idEvaluacion: number, idVariable: string) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVariable,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idVariable: idVariable }
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
  /**
    *@param idEvaluacion id numerico de la evaluacion AT 
   * @param idVariable string del codigo de la variable a consultar
  */
  async getDetalleCuenta(idEvaluacion: number, idCuenta: string) {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleCuenta,
          context: { headers: this.headers },
          variables: { idEvaluacion: idEvaluacion, idCuenta: idCuenta }
        }).valueChanges
      );
      return data;
    } catch (err) {
      console.log(err);
      return null;
    }
  }
}
